module.exports = __webpack_public_path__ + "static/img/xyshop.1d114a18.jpg";